module.exports = __webpack_public_path__ + "img/recomdNot.05b232db.png";